export function request(id) {
    id = parseInt(id, 10);

    return {
        type: 'BETSLIP_GET_REFERRED_REQUEST',
        id
    };
}

export function error(id, errors) {
    id = parseInt(id, 10);

    return {
        type: 'BETSLIP_GET_REFERRED_ERROR',
        errors,
        id
    };
}

export function finish({ id, bets, expiresAt, status, assignee, when }) {
    id = parseInt(id, 10);

    return {
        type: 'BETSLIP_GET_REFERRED_FINISH',
        results: bets,
        expiresAt,
        status,
        id,
        assignee,
        when
    };
}

export function clear(id) {
    id = parseInt(id, 10);

    return {
        type: 'BETSLIP_GET_REFERRED_CLEAR',
        id
    };
}
